import { useEffect } from 'react';
import { AppContext, AppMode } from '../http/protocol';
import { useDispatch } from 'react-redux';
import { setAppContext } from '../settings/SettingsActions';
import { setAppMode } from '../user/UserActions';

export const LOCALSTORAGE_APP_CONTEXT = "appContext";
export const LOCALSTORAGE_APP_MODE = "appMode";

const useGlifeCheckContextAndMode = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const appContext = localStorage.getItem(LOCALSTORAGE_APP_CONTEXT);
    const appMode = localStorage.getItem(LOCALSTORAGE_APP_MODE);

    if (appContext === AppContext.GLIFE && appMode === AppMode.EMBEDDED) {
      dispatch(setAppContext(AppContext.GLIFE));
      dispatch(setAppMode(AppMode.EMBEDDED));
    }
  }, []);

  return null;
};

export default useGlifeCheckContextAndMode;